export interface ChangeableRegulationInit {
  type?: string;
  until?: number;
}

export default class ChangeableRegulation {
  public readonly type?: string;
  public readonly until?: number;

  constructor(init: ChangeableRegulationInit) {
    this.type = init.type;
    this.until = init.until;
  }
}
